import {Component, EventEmitter, Input, Output} from '@angular/core';
import {TopbarNavLink, UPGRADE_QUERY_PARAMS} from './topbar-nav.constants';

// The top bar's destination rows. Two hosts render them: the phone sheet and
// the tablet dropdown. One markup source so the two surfaces stay the same menu.
@Component({
    selector: 'app-topbar-nav-links',
    templateUrl: './topbar-nav-links.component.html',
})
export class TopbarNavLinksComponent {
    @Input({required: true}) links!: TopbarNavLink[];
    readonly upgradeParams = UPGRADE_QUERY_PARAMS;

    // Null where the upgrade CTA is already on screen — the tablet keeps it in
    // the bar, so only the phone sheet sets this.
    @Input() upgradeLink: string | null = null;

    // Each host dismisses itself: dialog closes, panel hides.
    @Output() linkClick = new EventEmitter<void>();
}
